module.exports = __webpack_public_path__ + "media/images/cash-payment-6d310f339fe5201d7444749e4bda4af2.svg";